import { inject, provide, type InjectionKey } from 'vue';

import type { DataRefreshCoordinator } from './types';

const DATA_REFRESH_COORDINATOR_KEY: InjectionKey<DataRefreshCoordinator> = Symbol('data-refresh-coordinator');

export const provideDataRefreshCoordinator = (coordinator: DataRefreshCoordinator): void => {
  provide(DATA_REFRESH_COORDINATOR_KEY, coordinator);
};

export const useDataRefreshCoordinator = (): DataRefreshCoordinator => {
  const coordinator = inject(DATA_REFRESH_COORDINATOR_KEY);

  if (!coordinator) {
    throw new Error('Data refresh coordinator is not provided');
  }

  return coordinator;
};
